import moment from 'moment';
import { PacienteInfo } from '../types/types.patient';

export function convertData(input) {
  const OrderData = {
    ...input.Orden,
    AditionalFields: {},
  };

  delete OrderData.Dyn;

  for (const dynField of input.Dyn) {
    OrderData.AditionalFields[dynField.Equivalencia] = dynField.Valor;
  }

  const StudiesData: any = [];

  for (const study of input.Estudios) {
    const StudyData: any = {
      ...study.Data,
      AditionalFields: {},
    };

    for (const dynField of study.Dyn) {
      StudyData['AditionalFields'][dynField.Equivalencia] = dynField.Valor;
    }

    StudiesData.push(StudyData);
  }
  const idTransaction = input.IdTransaction ? input.IdTransaction : null;

  return {
    OrderData,
    IdOrder: input.Orden.Ord_Id,
    IdTran: idTransaction,
    StudiesData,
  };
}


export const ConvertDataPatient = (e) => {    
  const Patient: PacienteInfo[] = e as PacienteInfo[];
  const convertedObject = {
    ...Patient[0].Paciente,
    AditionalFields: {},
  };
  Patient.forEach((item) => {
    convertedObject.AditionalFields[item.Dyn[0].Equivalencia] = item.Dyn[0].Valor;
  });
  return convertedObject;
};

export const ConvertDataOrder= (e) => {    
  const Orden = e   
  const convertedObject = {
    ...Orden.Orden,
    AditionalFields: {},
  };
  Orden.Dyn.forEach((item) => {    
    convertedObject.AditionalFields[item.Equivalencia] = item.Valor;
  });  
  return convertedObject;
};

export const ConvertDataPatientOrders = (e) => {  
  const Patient: PacienteInfo = e as PacienteInfo;
  const convertedObject = {
    ...Patient.Paciente,
    AditionalFields: {},
  };
  Patient.Dyn.forEach((item) => {
    convertedObject.AditionalFields[item.Equivalencia] = item.Valor;
  });
  return convertedObject;
};

export function convertImageToBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function ConvertLocalDate(date) {
  // Restar 5 horas para ajustar a la hora de Colombia (UTC-5)
  const localDate = new Date(date);
  localDate.setHours(localDate.getHours() - 5);
  
  // Convertir la fecha ajustada a formato ISO 8601
  return localDate.toISOString();
}


  // Función para calcular la edad desde una fecha
  export const calculateAge = (birthDate: string | Date) => {
    if (!birthDate) return '';
    
    const now = moment();
    const birth = moment(birthDate);
    
    if (!birth.isValid()) return '';
    
    const totalDays = now.diff(birth, 'days');
    
    // Si es mayor o igual a 360 días (aproximadamente 1 año), mostrar en años
    if (totalDays >= 360) {
      const years = now.diff(birth, 'years');
      return `${years} ${years === 1 ? 'Año' : 'Años'}`;
    }
    
    // Si es mayor o igual a 30 días pero menor a 360 días, mostrar en meses
    if (totalDays >= 30) {
      const months = now.diff(birth, 'months');
      return `${months} ${months === 1 ? 'Mes' : 'Meses'}`;
    }
    
    // Si es menor a 30 días, mostrar en días
    return `${totalDays} ${totalDays === 1 ? 'Día' : 'Días'}`;
  };
